import { render } from "./news.vue?vue&type=template&id=d5122114&scoped=true"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"

import "./news.vue?vue&type=style&index=0&id=d5122114&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d5122114"

export default script